import { render } from "./PurgeCandidate.vue?vue&type=template&id=61d8f30d"
import script from "./PurgeCandidate.vue?vue&type=script&lang=js"
export * from "./PurgeCandidate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__